import { type HTMLAttributes, type FunctionComponent } from 'react';
import { formatPrice } from '../../../../helpers/general-helper/general-helper';

export type PriceRangeProps = {
	min: number;
	max?: number;
	squareFootageBased?: boolean;
} & Pick<HTMLAttributes<HTMLElement>, 'className'>;

/**
 * Price Range Component
 *
 * @param {PriceRangeProps} props
 */
export const PriceRange: FunctionComponent<PriceRangeProps> = ({ className = 'f5 font-medium', min, max, squareFootageBased = false }) => {
	return (
		<div className={className} data-testid="price-range">
			<strong>{formatPrice(min)}</strong>
			{max && max > min ? (
				<>
					<span className="mh1">-</span>
					<strong>{formatPrice(max)}</strong>
				</>
			) : null}
			{squareFootageBased ? <strong className="ml1">/ sq ft</strong> : null}
		</div>
	);
};
